import { render, staticRenderFns } from "./biddetail-dialog.vue?vue&type=template&id=793539db&scoped=true"
import script from "./biddetail-dialog.vue?vue&type=script&lang=js"
export * from "./biddetail-dialog.vue?vue&type=script&lang=js"
import style0 from "./biddetail-dialog.vue?vue&type=style&index=0&id=793539db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793539db",
  null
  
)

export default component.exports